import React, { useState, useEffect, Fragment } from "react";
import {
  Box, Avatar, Typography, Tabs, Tab, TextField, Button,
  Card, CardContent, IconButton, Container, styled
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import AlertService from "../../components/Alerts/alerts";
import axios from "axios";
import DetailedInfoTab from './DetailedInfoTab';  // Adjust the import path as needed


import AuthService from "../Authentication/auth.service";
// import AddressFormPopup from './AddressFormPopup';
import AddressService from './addressService';

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.error.main,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

const API_URL = process.env.REACT_APP_BASEURL;

const MyProfile = () => {
  const [tabValue, setTabValue] = useState(0);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("user")));
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [opass, setOpass] = useState("");
  const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });
  const [openPopup, setOpenPopup] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [storeduser, setStoredUser] = useState(JSON.parse(localStorage.getItem("user")));

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    if (!userData) {
      AuthService.logout();
      navigate("/login");
      window.location.reload();
    } else {
      decryptPass(userData.password);
      fetchAddresses();
    }
  }, []);

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const response = await AddressService.getAddresses();
      if (response.data.status) {
        setAddresses(response.data.data);
      } else {
        AlertService.swalErrorAlert(response.data.message || t("Error fetching addresses."));
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Error fetching addresses. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const decryptPass = (pass) => {
    let dec = atob(pass);
    setOpass(dec);
  };

  const handleUpdateBasicInfo = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.currentTarget);
    const payloadData = {
      functionName: "UpdateCustomerProfile",
      postData: {
        name: formData.get('fullName'),
        phone: formData.get('mobileNumber'),
        _id: userData._id
      },
    };
    SendSubmit(payloadData);
  };

  const handleUpdatePassword = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const oldPassword = formData.get('oldPassword');
    const newPassword = formData.get('newPassword');
    const confirmPassword = formData.get('confirmPassword');

    if (oldPassword !== opass) {
      AlertService.swalErrorAlert(t("Old password is incorrect. Please enter correct old password."));
      return;
    }
    if (newPassword !== confirmPassword) {
      AlertService.swalErrorAlert(t("Passwords do not match."));
      return;
    }

    setLoading(true);
    const payloadData = {
      functionName: "UpdateCustomerProfile",
      postData: {
        password: newPassword,
        _id: userData._id
      },
    };
    SendSubmit(payloadData);
  };

  const SendSubmit = (payload) => {
    sendUpdateProfile(payload).then((response) => {
      setLoading(false);
      if (response.data.status) {
        saveUpdatedCreds(payload, response.data.message);
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          AlertService.swalErrorAlert(response.data.message || t("Error: Can't update profile at the moment. Please try again later."));
        }
      }
    }).catch((error) => {
      setLoading(false);
      AlertService.swalErrorAlert(t("Network Operation failed."));
    });
  };

  const sendUpdateProfile = (payload) => {
    const headers = {
      'Content-Type': 'application/json',
      'token': localStorage.getItem("session-id")
    };
    return axios.post(API_URL, payload, { headers });
  };

  const saveUpdatedCreds = (payload, msg) => {
    let updatedUser = { ...userData };
    if (payload.postData.name) updatedUser.name = payload.postData.name;
    if (payload.postData.phone) updatedUser.phone = payload.postData.phone;
    if (payload.postData.password) updatedUser.password = btoa(payload.postData.password);

    localStorage.setItem("user", JSON.stringify(updatedUser));
    setUserData(updatedUser);

    AlertService.swalSuccessAlert(msg || t("Profile updated successfully.")).then(() => {
      window.location.reload();
    });
  };

  const handleAddAddress = () => {
    navigate('/add_address');
  };

  const handleEditAddress = (address) => {
    navigate(`/update_address`, { state: { address } });
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await AddressService.deleteAddress(addressId);
      if (response.data.status) {
        AlertService.swalSuccessAlert(t("Address deleted successfully."));
        fetchAddresses();
      } else {
        AlertService.swalErrorAlert(response.data.message || t("Error deleting address."));
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Error deleting address. Please try again."));
    }
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    setEditingAddress(null);
  };

  const handleSaveAddress = async (addressData) => {
    try {
      let response;
      console.log("addressData", addressData);
      if (editingAddress) {
        const data = {
          address_id: addressData._id,
          addressData: addressData,
          label: addressData.label,
          unit: addressData.unit,
          location: addressData.location,
          block: addressData.block
        }
        response = await AddressService.updateAddress(data);
      } else {
        let user_id = storeduser._id
        const data = {
          user_id: user_id,
          addressData: addressData,
          label: addressData.label,
          unit: addressData.unit,
          location: addressData.location,
          block: addressData.block
        }
        response = await AddressService.addAddress(data);
      }

      if (response.data.status) {
        AlertService.swalSuccessAlert(editingAddress ? t("Address updated successfully.") : t("Address added successfully."));
        fetchAddresses();
        handleClosePopup();
      } else {
        AlertService.swalErrorAlert(response.data.message || t("Error saving address."));
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Error saving address. Please try again."));
    }
  };

  const BasicInfoTab = () => (
    <Box component="form" onSubmit={handleUpdateBasicInfo} noValidate sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        id="fullName"
        label={t("Full Name")}
        name="fullName"
        autoComplete="name"
        defaultValue={userData?.name}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="mobileNumber"
        label={t("Mobile Number")}
        name="mobileNumber"
        autoComplete="tel"
        defaultValue={userData?.phone}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label={t("Email Address")}
        name="email"
        autoComplete="email"
        defaultValue={userData?.email}
        disabled
      />
      <StyledButton
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={loading}
      >
        {t("Update")}
      </StyledButton>
    </Box>
  );


  const DetailedInfoTabWrapper = () => (
    <DetailedInfoTab userData={userData} setUserData={setUserData} />
  );


  const AddressesTab = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <StyledButton
        variant="contained"
        onClick={handleAddAddress}
        sx={{ mb: 2, width: 'auto' }}
        disabled={loading}
      >
        {t("+ Add Address")}
      </StyledButton>
      {addresses.map((address) => (
        <Card key={address.id} sx={{ mb: 2, width: '100%', maxWidth: 400 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="h6" component="div">
                  {address.label}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {`${address.unit}, ${address.block}, ${address.location}`}
                </Typography>
              </Box>
              <Box>
                <IconButton onClick={() => handleEditAddress(address)} size="small">
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => handleDeleteAddress(address._id)} size="small">
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
      {/* <AddressFormPopup
        open={openPopup}
        handleClose={handleClosePopup}
        address={editingAddress}
        onSave={handleSaveAddress}
      /> */}
    </Box>
  );

  const PasswordTab = () => (
    <Box component="form" onSubmit={handleUpdatePassword} noValidate sx={{ mt: 1 }}>
      <TextField
        margin="normal"
        required
        fullWidth
        name="oldPassword"
        label={t("Old Password")}
        type={showPassword.old ? "text" : "password"}
        id="oldPassword"
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setShowPassword({ ...showPassword, old: !showPassword.old })}>
              {showPassword.old ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="newPassword"
        label={t("New Password")}
        type={showPassword.new ? "text" : "password"}
        id="newPassword"
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setShowPassword({ ...showPassword, new: !showPassword.new })}>
              {showPassword.new ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <TextField
        margin="normal"
        required
        fullWidth
        name="confirmPassword"
        label={t("Confirm Password")}
        type={showPassword.confirm ? "text" : "password"}
        id="confirmPassword"
        InputProps={{
          endAdornment: (
            <IconButton onClick={() => setShowPassword({ ...showPassword, confirm: !showPassword.confirm })}>
              {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        }}
      />
      <StyledButton
        type="submit"
        fullWidth
        variant="contained"
        sx={{ mt: 3, mb: 2 }}
        disabled={loading}
      >
        {t("Update")}
      </StyledButton>
    </Box>
  );

  if (!userData) return null;

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <Container maxWidth='md'>
            <Box sx={{ my: 4, textAlign: 'center' }}>
              <Avatar
                sx={{ width: 100, height: 100, margin: 'auto', bgcolor: 'error.main', fontSize: 40 }}
              >
                {userData.name.charAt(0).toUpperCase()}
              </Avatar>
              <Typography variant="h5" sx={{ mt: 2 }}>{userData.name}</Typography>
              <Typography variant="body1" color="text.secondary">{userData.phone}</Typography>
            </Box>

            <Tabs value={tabValue} onChange={handleTabChange} centered>
              <StyledTab label={t("Basic Info")} />
              <StyledTab label={t("Addresses")} />
              <StyledTab label={t("Password")} />
              <StyledTab label={t("Detailed Info")} />
            </Tabs>

            <Box sx={{ mt: 3 }}>
              {tabValue === 0 && <BasicInfoTab />}
              {tabValue === 1 && <AddressesTab />}
              {tabValue === 2 && <PasswordTab />}
              {tabValue === 3 && <DetailedInfoTabWrapper />}
            </Box>
          </Container>
        </div>
      </div>
    </Fragment>
  );
};

export default MyProfile;